
export default field_validator_args => {
  const chinese_char_pattern = /[\u4e00-\u9fa5]/
  const default_message = '不能包含任何中文字元'
  const { value, message = default_message, customArgs: custom_args } = field_validator_args

  let continue_to_validate = true
  if (custom_args && custom_args.hasOwnProperty('condition')) {
    if (typeof custom_args.condition === 'function') {
      continue_to_validate = custom_args.condition()
    } else {
      continue_to_validate = custom_args.condition
    }
  }

  const validation_result = {
    succeeded: true,
    type: 'CONTAINS_NO_CHINESE_CHARACTERS_VALIDATOR',
    message: ''
  }
  
  if (continue_to_validate && chinese_char_pattern.test(value)) {
    validation_result.succeeded = false
    validation_result.message = message
  }

  return validation_result;
}
